<div class="causes-section">
  <div class="content-container">
    <div class="top-heading">
      <h2>Causes you can raise funds for</h2>
      <p>Count on us for the cause that you want to raise funds for</p>
    </div>
    <app-startfundraiser-button *ngIf="!isMobile" label="Start a Fundraiser for FREE" pageName="home" width="300px" height="48px"></app-startfundraiser-button>
  </div>
  <div class="cause-list-container"> 
    <app-causes-list-v3></app-causes-list-v3>
  </div>
  <div class="mweb-cta" *ngIf="isMobile">
    <app-startfundraiser-button label="Start a Fundraiser for FREE" pageName="home" width="100%" height="36px"></app-startfundraiser-button>
  </div>
</div>